import { Model } from 'backbone';

/**
 * This is Advertising Model Class
 */
export default class AdvertisingModel extends Model {
	/**
	 * Set default model fields
	 * @returns object
	 */
	defaults() {
		return {
			'fantasy/leagues':       [
				'league-manage-ad-slot-1',
				'league-manage-ad-slot-2',
				'league-manage-ad-slot-3'
			],
			'fantasy/league/create': [
				'league-create-ad-slot-1',
				'league-create-ad-slot-2',
				'league-create-ad-slot-3'
			],
			'fantasy/league/join':   [
				'league-join-confirm-ad-slot-1',
				'league-join-confirm-ad-slot-2',
				'league-join-confirm-ad-slot-3'
			],
			'current_sidebar_ad':    'league-manage-ad-slot-1',
			'current_footer_ad':     'league-manage-ad-slot-3'

		}
	}

	setSidebarAd( url ) {
		let ad = this.get( url );

		if( ad && ad[0] ) {
			this.set( 'current_sidebar_ad', ad[0] );
		}

		return this;
	}

	setFooterAd( url ) {
		let ad = this.get( url );

		if( ad && ad[0] ) {
			this.set( 'current_footer_ad', ad[0] );
		}

		return this;
	}
}